<div class="p-4">
  <div
    class="flex flex-wrap gap-3 justify-start"
  >
  @for (h of heightService.heights(); track h) {
    <div
      class="color-swatch flex flex-col items-center border rounded-md p-2 cursor-pointer transition-all w-20 sm:w-25 md:w-28"
      [class.selected]="h === heightService.selectedHeight()"
      (click)="selectHeight(h)"
    >
      <div class="swatch-box w-17 h-17 sm:w-22 sm:h-22 md:w-25 md:h-25 mb-1 rounded flex items-center justify-center">
        <img
          src="images/heights/{{h}}.jpg"
          alt="{{ h }} inches high"
          class="max-w-full max-h-full object-contain"
        />
      </div>

      <div class="text-xs text-center truncate w-full">
        <strong>{{ h }}" High</strong>
      </div>
    </div>
  }
  </div>
</div>
